export default __webpack_public_path__ + "static/badge_aws_sysops_admin-9e2568d4d36bdf4193cce01106a0ea3f.png";